import sthetoscopeBgImage from '../assets/sthetoscope2.jpg';

const styles = theme => ({
  requestFormDesktop: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'center',
    width: '100vw',
    height: 'auto',
    minHeight: '100vh',
    backgroundImage: `url(${sthetoscopeBgImage})`,
    backgroundSize: 'cover',
  },

  requestFormMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    width: '100vw',
    height: 'auto',
    minHeight: '100vh',
    backgroundImage: `url(${sthetoscopeBgImage})`,
    backgroundSize: 'cover',
  },
  bedsAvailabilityDesktop: {
    flex: 1
  },
  bedsAvailabilityHistoryDesktop: {
    flex: 1
  },

  chartsDesktop: {
    display: 'flex',
    flexDirection: 'column',
    margin: 40,
    marginTop: 100,
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    flex: 1
  },

  chartsMobile: {
    display: 'flex',
    flexDirection: 'column',
    margin: 10,
    marginTop: 70,
    alignItems: 'stretch',
    justifyContent: 'space-between',
    flex: 1
  },
  appHeader: {
    position: 'absolute',
  },
  formTitle: {
    marginBottom: 10,
    textAlign: 'center',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '1.4rem',
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    flex: 1,
  },
  flexFormContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: 20,
    flex: 1,
  },

  requestFormTablet: {
    display: 'grid',
    width: '100vw',
    height: 'auto',
    minHeight: '100vh',
    gridTemplateRows: '100px 1fr 150px',
    gridTemplateColumns: '30px 1fr 10px 1fr 30px',
    backgroundImage: `url(${sthetoscopeBgImage})`,
    backgroundSize: 'cover',

  },
  bedsAvailabilityCardTablet: {
    gridRow: '2',
    gridColumn: '4',
    height:'512px'
  },
  spinnerContainer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '25vh',
    width: '100%',
    display: 'grid'
  },
  spinner: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    display: 'grid',
    marginBottom: 20
  },
  bedsAvailabilityCardRootTablet: {
    display: 'grid',
    minHeight: '512px',
    maxHeight: '512px',
    gridTemplateRows: '20px 60px 2fr 60px 60px',
    gridTemplateColumns: '30px 1fr 30px',
    alignItems: 'flex-start',
    //height: 'calc(100vh - 300px)',
    height: '-webkit-calc(100vh - 300px)'
  },
  formContainerTablet: {
    gridRow: '2',
    gridColumn: '2',
    minHeight: '512px',
    maxHeight: '512px',
    height: 'calc(100vh - 280px)',
  },

  announceTablet: {
    padding: '10px 30px',
    gridRow: '3',
    gridColumn: '1 / span 5',
  },

  formContainerMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    padding: 20,
    marginBottom: 10,
    flex: 1,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '20px -40px 20px 20px',
    width: 'calc(100% - 40px)',
  },
  formField: {
    width: '100%',
  },
  nameRow: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '15px',
    marginBottom: 5,
  },
  contact: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 20,
  },
  contactField: {
    width: '45%',
  },
  sendButton: {
    width: '25vw',
    marginTop: 40,
  },
  allBedsCountNumber: {
    color: '#333333',
  },
  overBedsCountNumber: {
    color: '#FF3333',
  },
  freeBedsCountNumber: {
    color: '#029AB1',
  },
  allBedsCountTablet: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
    flex: 1,
  },

  countersTablet: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    textAlign: 'center',
    flex: 1,
  },

  freeBedsCountTablet: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
    flex: 1,
  },
});

export default styles;